import { render } from "./aStatus.vue?vue&type=template&id=07f5f2de"
import script from "./aStatus.vue?vue&type=script&lang=js"
export * from "./aStatus.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__